import axios from '../../axios.js'

if (localStorage.getItem('token') && !axios.defaults.headers.common['Authorization']) {
  const accessToken = localStorage.getItem('token')
  axios.defaults.headers.common['Authorization'] = `${accessToken}`
}

export default axios
